import React, { useCallback } from "react";
import "./moftabakh.css";
import {
  FocusContext,
  useFocusable,
  setFocus,
} from "@noriginmedia/norigin-spatial-navigation";
import Lottie from "react-lottie-player";
import lottieJson from "../../moftabakh.json";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import { FOCUS_BORDER } from "../../config/focusStyles";
import { useInputMode } from "../../utils/hooks/useInputMode";

const MoftabakhContainer = styled.div`
  width: calc(100% - 5rem);
  min-height: 440px;
  background-image: url(/moftabakh.png);
  border-radius: 20px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: ${props => props.$focused ? FOCUS_BORDER.active : FOCUS_BORDER.inactive};
  position: relative;
  overflow: hidden;
  z-index: ${props => props.$focused ? 10 : 0};
  margin: 2px auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const MoftabakhLogo = () => {
  return (
    <div className="inset-0 z-10">
      <div className="w-48 ml-48 rounded-xl mr-auto">
        <Lottie
          loop
          animationData={lottieJson}
          play={true}
          style={{
            width: 365,
            borderRadius: "20px",
            transition: "all ease .3s",
          }}
        />
      </div>
    </div>
  );
};

const MoftaBakh = ({ onFocus, index }) => {
  const navigate = useNavigate();
  const { focused, focusKey, ref, focusSelf } = useFocusable({
    onFocus,
    focusKey: "moftabakh_home",
    isFocusBoundary: true,
    focusBoundaryDirections: ["left"],
    onEnterPress: () => navigate("/moftabakh"),
    onArrowPress: (direction) => {
      if (direction === "right") {
        setFocus("MENU");
        return false;
      }
      return true;
    },
  });

  const { setMouseFocus } = useInputMode();
  const handleMouseEnter = useCallback(() => {
    setMouseFocus(true);
    focusSelf();
  }, [focusSelf, setMouseFocus]);

  return (
    <FocusContext.Provider value={focusKey}>
      <Link ref={ref} to="/moftabakh" onMouseEnter={handleMouseEnter}>
        <MoftabakhContainer $focused={focused} tabIndex={index}>
          <MoftabakhLogo />
        </MoftabakhContainer>
      </Link>
    </FocusContext.Provider>
  );
};

export default MoftaBakh;
